import React from 'react';
import PropTypes, { oneOfType } from 'prop-types';
import cn from 'classnames';
import Button from '@Components/Button';

import './CustomGroupsBar.scss';

function CustomGroupButton(props) {
  const { group, onClick, isActive } = props;
  const { size, title } = group;
  const parsedSize = parseInt(size, 10);

  return (
    <Button
      disabled={!parsedSize}
      onClick={onClick}
      buttonConfig={{
        className: cn('custom-groups-bar__button', { active: isActive }),
        type: 'link',
        label: title,
        color: 'blue',
        size: 'sm',
        e2eName: 'custom-group',
      }}
    />
  );
}

CustomGroupButton.propTypes = {
  onClick: PropTypes.func,
  isActive: PropTypes.bool,
  group: PropTypes.shape({ size: oneOfType([PropTypes.number, PropTypes.string]), title: oneOfType([PropTypes.number, PropTypes.string]) }),
};

const letters = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
  '0-9',
  'Other',
];

function CustomGroupsBar(props) {
  const { customGroupsData, activeCustomGroupIndex, setActiveCustomGroupIndex, dialogId, sorting, onAscending } = props;
  const handleCustomGroupIndexClick = (index) => {
    setActiveCustomGroupIndex(dialogId, index);
    if (sorting !== 'ascending') {
      onAscending();
    }
  };
  return (
    <ul className="custom-groups-bar">
      {customGroupsData &&
        letters.map((letter) => {
          const group = customGroupsData.find((item) => item.title === letter);
          if (!group) {
            return (
              <li className="custom-groups-bar__item_disabled" key={`custom-groups-bar-item_${letter}`}>
                {letter}
              </li>
            );
          }
          return (
            <li className="custom-groups-bar__item" key={`custom-groups-bar-item_${letter}_${group.index}`}>
              <CustomGroupButton
                group={group}
                isActive={activeCustomGroupIndex === group.index}
                onClick={() => handleCustomGroupIndexClick(group.index)}
              />
            </li>
          );
        })}
    </ul>
  );
}

CustomGroupsBar.defaultProps = {
  setActiveCustomGroupIndex: () => {},
};

CustomGroupsBar.propTypes = {
  customGroupsData: PropTypes.array,
  activeCustomGroupIndex: PropTypes.string,
  setActiveCustomGroupIndex: PropTypes.func,
  dialogId: PropTypes.string,
  sorting: PropTypes.string,
  onAscending: PropTypes.func.isRequired,
};

export default CustomGroupsBar;
